import type { CustomerIdentityDTO } from '@sac/contracts'
import { ChannelMark, Icon, channelName } from '../icons'

export function IdentityMatch({
  customerName,
  identities,
  onLink,
  onReject,
}: {
  customerName: string
  identities: CustomerIdentityDTO[]
  onLink: (identityId: string) => void
  onReject: (identityId: string) => void
}) {
  return (
    <div className="match">
      <h4>
        <Icon name="link" size={14} />
        Possível correspondência encontrada
      </h4>
      <p>Identificamos contas em canais diferentes que parecem pertencer à mesma pessoa.</p>
      <div className="ids">
        {identities.map((id) => (
          <div className="idcard" key={id.id}>
            <ChannelMark channel={id.channelType} size={18} />
            <span>
              <span className="t1">{channelName(id.channelType)}</span>
              <br />
              <span className="t2">{id.username ?? id.phone ?? id.email ?? id.externalUserId}</span>
            </span>
          </div>
        ))}
      </div>
      <div className="acts">
        <button className="btn pri" onClick={() => identities[0] && onLink(identities[0].id)}>
          Vincular perfis
        </button>
        <button className="btn sec" onClick={() => identities[0] && onReject(identities[0].id)}>
          Não é a mesma pessoa
        </button>
      </div>
    </div>
  )
}
